export default "__VITE_ASSET__CUXpxtPK__"